import type { FigmaIconProps } from './types';

export const IconFigmaFilter = ({ size = 14, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8333 1.16667C13.0604 1.16667 13.267 1.29846 13.3625 1.50448C13.4581 1.71044 13.4254 1.95315 13.2788 2.12655L8.75 7.48136V12.25C8.75 12.4522 8.64512 12.6399 8.47314 12.7462C8.30119 12.8524 8.08654 12.8622 7.90576 12.7718L5.57243 11.6051C5.3748 11.5063 5.25 11.3043 5.25 11.0833V7.48136L0.721191 2.12655C0.574621 1.95315 0.541894 1.71044 0.637451 1.50448C0.733035 1.29846 0.93956 1.16667 1.16667 1.16667H12.8333ZM6.27881 6.89176C6.36781 6.99705 6.41666 7.13045 6.41667 7.26831V10.7227L7.58333 11.3061V7.26831C7.58334 7.13045 7.63219 6.99705 7.72119 6.89176L11.5761 2.33333H2.42391L6.27881 6.89176Z"
      fill={color}
    />
  </svg>
);
